package com.essntl.features.service.ui.allservice.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.outline.EsLargeOutlineButton

@Composable
fun LoadMoreItems(
    onLoadMore: () -> Unit,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .padding(bottom = 10.dp),
    ) {
        EsLargeOutlineButton(
            onClick = onLoadMore,
            text = "Load More",
            loading = isLoading,
        )
    }
}